import React, { useState, useEffect } from "react";
import "./dashboard.css";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import InfoCard from "../../components/InfoCard/InfoCard";
import iconMember from "../../images/icons/DMembers.png";
import iconProduct from "../../images/icons/iconProduct.png";
import iconPayslip from "../../images/icons/iconPayslip.png";
import iconExpoLot from "../../images/icons/iconExpoLot.png"
import getToken, { redirectToLogin } from "../../pages/getToken";
import authStore from "../../store/authStore";
import ChatItem from "../../components/ChatItem/chatItem";
import MemberChart from "../../components/MemberChart/memberChart";

const Dashboard = () => {

  const [dashboardInfo, setDashboardInfo] = useState({
    memberCount: 0,
    productCount: 0,
    lotCount: 0,
    monthCounts: [],
    onlineUsers: []
  });

  const brandId = authStore((state) => state.auth?.brandId);
  const getDashboardInfo = () => {
    api
      .get("Admin/GetDashboardInfo", { BrandId: brandId }, getToken())
      .then((result) =>
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              redirectToLogin();
            } else if (response.data.code === 200) {
              setDashboardInfo(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            alert(error);
          }
        )
      );
  };

  const online_users = dashboardInfo.onlineUsers;

  useEffect(() => {
    getDashboardInfo();
  }, []);

  return (

    <div className="dashboard">
      <div className="content">
        <div className="CardList flex flex-wrap col-sm-12">
          <InfoCard
            title="စုစုပေါင်း ကုန်သည်"
            count={dashboardInfo?.memberCount ?? 0}
            // sale="+ 32.12%"
            icon={iconMember}
            iconWidth="24px"
          />
          <InfoCard
            title="စုစုပေါင်း ကယ်ရီ"
            count={dashboardInfo?.productCount ?? 0}
            icon={iconProduct}
            iconWidth="29px"
          />
          {/* <InfoCard
            title="စုစုပေါင်း ပြေစာ"
            count={dashboardInfo.payslipCount ?? 0}
            sale="+ 32.12%"
            icon={iconPayslip}
            iconWidth="26px"
          /> */}
          <InfoCard
            title="စုစုပေါင်း ရောင်းပြီး ကုန်စည်"
            count={dashboardInfo.lotCount ?? 0}
            // sale="+ 32.12%"
            icon={iconExpoLot}
            iconWidth="26px"            // sale="+ 32.12%"

          />
        </div>

        {/* Chart  */}
        <div className="member-chart">
          <MemberChart data={dashboardInfo.monthCounts} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
